export const TOGGLE_KEYBOARD_NAVIGATION = 'TOGGLE_KEYBOARD_NAVIGATION';

// FooterBar configuration constants
export const SET_FOOTER_PROPS = 'SET_FOOTER_PROPS';
export const RESET_FOOTER_PROPS = 'RESET_FOOTER_PROPS';

// Selection mode enum - kept for compatibility, but state lives in Zustand
export const SELECTION_MODE = {
    COPY: 'copy',
    MOVE: 'move'
};